// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"494f63ed","455":"5c010578","644":"22cae7a0"}[chunkId] + ".chunk.js";
};